var parkingFormsInit = function () {

    $('[data-id="change-discount-button"]').on('click', function (evt) {
        evt.preventDefault();

        var discountContainer = $('[data-id="discount-select-container"]');
        var changeDiscountContainer = $('[data-id="change-discount-container"]');

        discountContainer.show();
        changeDiscountContainer.hide();
    });

    $('[data-id="address-finder-restricted-manual-button"]').on('click', function (evt) {
        evt.preventDefault();

        var restrictedManualEntryContainer = $('[data-id="manual-address-restricted-container"]');

        restrictedManualEntryContainer.show(300);

        if (restrictedManualEntryContainer.hasClass('x'))
            restrictedManualEntryContainer.removeClass('x');
    });

};
